import { Text } from '@chakra-ui/react';

export default function FilterResultCount({filteredResultCount}) {

    return (
        <Text width={"200px"} fontWeight={600} pb={2}>
            {`Showing filter result : ${filteredResultCount}`}
        </Text>
    );
}
